import { render } from "./MovieItem.vue?vue&type=template&id=1b1e3546&scoped=true"
import script from "./MovieItem.vue?vue&type=script&lang=js"
export * from "./MovieItem.vue?vue&type=script&lang=js"

import "./MovieItem.vue?vue&type=style&index=0&id=1b1e3546&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1e3546"]])

export default __exports__